import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VInput } from '@/package';

import type { TaskCreateFormType } from './type';

export const TaskName = ({
  readOnly,
  isEditing,
}: {
  readOnly: boolean;
  isEditing: boolean;
}) => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    setValue,
    formState: { touchedFields },
  } = useFormContext<TaskCreateFormType>();

  const name = watch('taskName');
  const orgPath = watch('orgPath');
  const validate = (value?: string) => {
    return Boolean(value && value.length > 0);
  };

  useEffect(() => {
    if (!touchedFields.taskName && !isEditing) setValue('taskName', orgPath);
  }, [orgPath, isEditing]);

  return (
    <VInput
      fluid
      required
      label={t('task.createTaskNameLabel.tricklet')}
      placeholder={t('task.createTaskNamePlaceholder.archpresbytery')}
      {...register('taskName', { validate })}
      valid={!touchedFields.taskName || validate(name)}
      readOnly={readOnly}
    />
  );
};
